/* @flow */

import * as React from 'react';

import '../ProgressBar.css';

const EmptyProgressBar = (): React.Node => (
  <div className='progressBar'>
    <div className='reactiveBackground'>
      <div className='mainContainer' />
    </div>
  </div>
);

export default EmptyProgressBar;
